import styled from 'styled-components'

export const FlexStyle = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: space-around;
  align-items: center;
`
